module.exports = __webpack_public_path__ + "static/media/slide-9.f725c6bd.png";